import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DropList } from '../users/users.model';
import { ClearingHouseBO } from './clearing-house.model';

@Injectable({
  providedIn: 'root'
})
export class ClearingHouseService {
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    })
  };
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getClearingHousePayorMapping(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClearingHouse/GetClearingHouseDetails?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdate(saveList: ClearingHouseBO): Observable<string> {
    let url = "api/ClearingHouse/SaveClearingHouse";
    return this.http.post<string>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  deleteClearingHousePayorMapping(id: string): Observable<any> {
    let url = "api/ClearingHousePayorMapping/DeleteClearingHousePayorMapping/" + id;
    return this.http.delete<number>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getReceiver_id_qualifier(paramsData: URLSearchParams): Observable<DropList[]> {
    let url = "api/LOV/LovDropDownQualifier?";
    return this.http.get<DropList[]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getSenderIdQualifier(paramsData: URLSearchParams): Observable<DropList[]> {
    let url = "api/LOV/LovDropDownQualifier?";
    return this.http.get<DropList[]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
